@if (totalCount > 0) {
  <div class="pagination-wrapper" [class.disabled]="loading">
    @if (showPageSize) {
      {{ 'default.pagination.itemsPerPage' | translate }}: {{ pageSize }}
    }
    @if (showTotalCount) {
      <span class="hidden-on-mobile">
      {{ currentPage * pageSize + 1 }}
      &ndash; {{ (currentPage * pageSize + pageSize) > totalCount ? totalCount : currentPage * pageSize + pageSize }}
      {{ 'default.pagination.of' | translate }} {{ totalCount }}
      </span>
    }
    <div class="content-layout">
      <button type="button" class="button icon-button" (click)="onChangePage(displayCurrentPage - 1)"
              [disabled]="currentPage <= 0">
        <app-icon name="ic_chevron_left"/>
      </button>

      <div class="content">
        <span>{{ 'default.pagination.page' | translate }}</span>
        <div class="input-wrapper">
          <input class="input-field" type="number" min="1" [max]="length" step="1" name="displayCurrentPage" [disabled]="length == 1"
                 [ngModel]="displayCurrentPage" (ngModelChange)="onChangePage($event)">
        </div>
        <span class="distance">{{ 'default.pagination.of' | translate }}</span> {{ length }}
      </div>

      <button type="button" class="button icon-button" (click)="onChangePage(displayCurrentPage + 1)"
              [disabled]="displayCurrentPage >= length">
        <app-icon name="ic_chevron_right"/>
      </button>
    </div>
  </div>
}
